import { render, staticRenderFns } from "./dzProfit.vue?vue&type=template&id=2dfb08c0&scoped=true&"
import script from "./dzProfit.vue?vue&type=script&lang=js&"
export * from "./dzProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb08c0",
  null
  
)

export default component.exports